import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// reactstrap components
import { Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// API
import { api_GET, api_POST } from "../../../services/api_service";

//Helpers
import { showMessage } from "../../../services/message";

//Context
import { useAuth } from "../../../context/auth";

//Components
import DadosObra from "../../Shared/GeradorPGRCC/DadosObra";
import DestinoPGRCC from "../../Shared/GeradorPGRCC/DestinoPGRCC";
import Declaracao from "../../Shared/Declaracao";
import Documentos from "../../Shared/Documentos";
import ExecutorObra from "../../Shared/GeradorPGRCC/ExecutorObra";
import Identificacao from "../../Shared/Gerador/Identificacao";
import GeradorObra from "../../Shared/GeradorPGRCC/GeradorObra";
import PlanoResiduoDetalhamento from "../../Shared/GeradorPGRCC/PlanoResiduoDetalhamento";
import PlanoResiduoModelo from "../../Shared/GeradorPGRCC/PlanoResiduoModelo";
import InformacoesComplementares from "../../Shared/GeradorPGRCC/InformacoesComplementares";
import TransportadoresPGRCC from "../../Shared/GeradorPGRCC/TransportadoresPGRCC";
import CardRejeicaoRequerimento from "../components/CardRejeicaoRequerimento";


export default function GeradorPGRCCRequerimentoRenovacaoCadastro() {
    const { session, setLoading, setupSistema } = useAuth();

    const location = useLocation();

    const [requerimento, set_requerimento] = useState(null);

    // State para pega a opção do cadastro
    const [opcao, set_opcao] = useState(null);

    // State para definir o passa a passa do formulário
    const [steps] = useState([
        "Gestor do PGRCC",
        "Gerador da Obra",
        "Executor da Obra",
        "Dados da Obra",
        "Plano de Resíduos - Modelo",
        "Plano de Resíduos - Detalhamento",
        "Transportadores",
        "Destinos",
        "Informações Complementares",
        "Documentos"
    ]);

    const [step, set_step] = useState(0);
    const handleProximoStep = (_requerimento) => {
        set_requerimento(_requerimento);
        set_step(step + 1);
    }

    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = async () => {
        setLoading(true);
        try {
            if (location.state.requerimento == null) {
                const json_submit = {
                    protocolo_Id: location.state.protocolo.protocolo_Id,
                    requerimento_Id: 0,
                    nomeSolicitante: location.state.protocolo.nomeSolicitante,
                    email: location.state.protocolo.email,
                    cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                    setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
                };

                const result = await api_POST('requerimento/PostRequerimento', json_submit);

                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: "Grande Gerador - PGRCC",
                    categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });
                set_requerimento(result.data);
                set_step(0);
            } else {
                const result = await api_GET('requerimento/' + location.state.requerimento.requerimento_Id);

                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: "Grande Gerador - PGRCC",
                    categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });
                set_requerimento(result.data);

                if (result.data.status === "Divergente") {
                    set_step(0);
                } else if (result.data.etapaCadastro != null) {
                    set_step(result.data.etapaCadastro);
                }
            }
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && opcao != null &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    <CardRejeicaoRequerimento requerimento={requerimento} setupSistema={setupSistema} />
                    {step === 0 && (
                        <Identificacao
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                        />
                    )}

                    {step === 1 && (
                        <GeradorObra
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 2 && (
                        <ExecutorObra
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 3 && (
                        <DadosObra
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 4 && (
                        <PlanoResiduoModelo
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 5 && (
                        <PlanoResiduoDetalhamento
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 6 && (
                        <TransportadoresPGRCC
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 7 && (
                        <DestinoPGRCC
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 8 && (
                        <InformacoesComplementares
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 9 && (
                        <Documentos
                            item={requerimento}
                            opcao={opcao}

                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 10 && (
                        <Declaracao
                            item={requerimento}
                            handleFinalizarCadastro={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}
                </div>
            }

            {requerimento != null && opcao != null && step == 11 &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    )
}
